/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-align:end;align-items:flex-end}.indicator[_ngcontent-%COMP%]{width:6px;margin-right:3px;background:#e1e1e1;border-radius:4px}.inverted[_ngcontent-%COMP%]{background:rgba(255,255,255,.3)}.active[_ngcontent-%COMP%]{background:#333}.active-inv[_ngcontent-%COMP%]{background:#e1e1e1}"];
export { styles as styles };
